import React from 'react';
import '../UploadForm.css';
import GeneralTooltip from '../common/GeneralTooltip.js';
import SvgIcon from '../common/SvgIcon';
import TrashIcon from '../../assets/icons/trash_icon.svg';
import LockIcon from '../../assets/icons/lock_icon5.svg';
import LockedIcon from '../../assets/icons/lock_icon.svg';
import CopyIcon from '../../assets/icons/copy_icon.svg';
import CheckIcon from '../../assets/icons/check_icon.svg';

function KeywordUtilities({
  keywordsLocked,
  onToggleLock,
  onClearAll,
  onCopy,
  copyStatus,
}) {
  return (
    <div className="keyword-utilities-container">
      <div className="utility-wrapper">
        <GeneralTooltip
          content={<div style={{ padding: '4px' }}>{keywordsLocked ? 'Keywords locked!' : 'Lock current keywords'}</div>}
          position="top"
          delay={100}
          verticalOffset={4}
          triggerClassName="lock-keywords-button"
        >
          <button onClick={onToggleLock} className={`lock-keywords-button ${keywordsLocked ? 'locked' : ''}`}>
            <img className="lock-image" alt="lock icon" src={keywordsLocked ? LockedIcon : LockIcon} />
          </button>
        </GeneralTooltip>
      </div>

      <div className="utility-wrapper">
        <GeneralTooltip content={<div style={{ padding: '4px' }}>Clear all keywords</div>} position="top" delay={100} verticalOffset={7} triggerClassName="clear-keywords-button">
          <button onClick={onClearAll} className="clear-keywords-button">
            <SvgIcon src={TrashIcon} color="#ddd" hoverColor="#ff4f4f" size="26px" className="exit-icon" />
          </button>
        </GeneralTooltip>
      </div>

      <div className="utility-wrapper">
        <GeneralTooltip
          content={<div style={{ padding: '4px' }}>{copyStatus?.copied ? 'Copied to clipboard!' : 'Copy all keywords'}</div>}
          position="top"
          delay={100}
          verticalOffset={4}
          triggerClassName="copy-keywords-button"
        >
          <button onClick={onCopy} className="copy-keywords-button">
            <img src={copyStatus?.copied ? CheckIcon : CopyIcon} alt={copyStatus?.copied ? 'Copied!' : 'Copy keywords'} />
          </button>
        </GeneralTooltip>
      </div>
    </div>
  );
}

export default KeywordUtilities;


